import React from "react";

import {makeStyles} from "@material-ui/core";

import {ERROR_COLOR, ERROR_BACKGROUND} from "../../../../../../../../../../themes/themeConfigurator";
import {useConfirmationModalContext} from "../../../../../../../../../../components/ConfirmationModalContextProvider";


const useStyles = makeStyles((theme) => ({
  buttonCancel: {
    color: theme.palette.secondary.main,
  },
  dialogTitle: {
    background: ERROR_BACKGROUND,
  },
  messageContent: {
    paddingTop: theme.spacing(2),
  }
}))

const useCancelSelection = ({hasSelectedAssets, handleClose, handleNextClick}) => {
  const classes = useStyles();
  const modalContext = useConfirmationModalContext();

  return async () => {
    if (hasSelectedAssets) {
      const confirmResult = await modalContext.confirm(
        'Wollen Sie Ihre Änderungen speichern?',
        "Ja, speichern",
        "Nein, verwerfen",
        <>
          <i
            className={"far fa-exclamation-triangle"}
            style={{color: ERROR_COLOR, marginRight: 10}}
          />Nicht gespeicherte Änderungen
        </>,
        classes
      );

      if (confirmResult === false) {
        handleClose();
      } else if (confirmResult === true) {
        handleNextClick()
      }
    } else {
      handleClose();
    }
  };
}

export default useCancelSelection;